import { URLBACK } from '../../assets/urls'
import { User } from '../../reducers/userReducer'

export const handleLogout = async (jwt, dispatch, axios) => {
  axios.post(`${URLBACK}jwts`, {
    token: jwt,
  })
  dispatch(User.actions.logout({}))
}
